import { useProcessDataContext } from '@datapeace/vms-visitor-models';
import { SharedFaceCapture } from '@datapeace/vms-visitor-screens';

export function CheckinByFace() {
  const {
    handleCheckinByFaceSubmit,
    goBack,
    updateProcessData,
    consentConfig,
  } = useProcessDataContext();
  const handleConsentChange = (_given: boolean, timestamp?: string) => {
    updateProcessData({ consentProvidedAt: timestamp ?? null });
  };
  return (
    <SharedFaceCapture
      onCapture={handleCheckinByFaceSubmit}
      goBack={goBack}
      consentConfig={consentConfig}
      onConsentChange={handleConsentChange}
    />
  );
}
